/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from '@env/environment';

import { GTMService } from '@personal-area/global/gtm';

import { appBrowserProviders } from './app/app.browser.module';
import { AppComponent } from './app/app.component';
import { Hotjar } from './app/core/utility/hotjar';

if (environment.hotjar.enable) {
  Hotjar.createSession(
    environment.hotjar.trackingId,
    environment.hotjar.version,
  );
}

if (environment.gtm.enable) {
  GTMService.createGTMSession(environment.gtm.trackingId);
}

bootstrapApplication(AppComponent, {
  providers: appBrowserProviders,
}).then(() => {
  if ('serviceWorker' in navigator && environment.production) {
    navigator.serviceWorker.register('/cabinet/ngsw-worker-polyfill.js');
  }
});
